import { FC } from "react";

import { useScrollToHashOnFirstRender } from "shared/utils";

import {
  BandSummary,
  RegionalSettings,
  EventSettings,
  Subscription,
  MemberSettings,
} from "./containers";

export const BandSettingsPage: FC = () => {
  useScrollToHashOnFirstRender();

  return (
    <>
      <BandSummary />
      <Subscription />
      <RegionalSettings />
      <EventSettings />
      <MemberSettings />
    </>
  );
};
